import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a 1 m kitchen sink base unit matching kitchen-counter
// (0.6 m deep, 0.9 m worktop, back flush at z = -0.3): same carcass, door
// fronts and worktop, with a steel basin inset into the top (a shallow
// open-look box: dark inner slab + raised steel rim) and a tall faucet.
const CARCASS = "#e8e4dc";
const FRONT = "#efece6";
const WORKTOP = "#d8d5cf";
const MATTE_BLACK = "#2e2e30";
const STEEL = "#aab2b8";
const BASIN = "#8d959b";

export const kitchenSink = defineModel({
  id: "kitchen-sink",
  batchId: "modern",
  name: "Kitchen sink",
  tags: ["modern", "interior", "fixture", "kitchen", "sink", "counter"],
  summary: "A one-metre sink base unit with a steel basin and tall faucet.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(0.94, 0.1, 0.5), color: MATTE_BLACK, position: [0, 0.05, -0.04] },
      // cabinet carcass (back flush at z = -0.3)
      { geometry: new THREE.BoxGeometry(1.0, 0.76, 0.56), color: CARCASS, position: [0, 0.48, -0.02] },
      // two door fronts
      { geometry: new THREE.BoxGeometry(0.46, 0.72, 0.02), color: FRONT, position: [-0.245, 0.49, 0.27] },
      { geometry: new THREE.BoxGeometry(0.46, 0.72, 0.02), color: FRONT, position: [0.245, 0.49, 0.27] },
      // thin bar handles
      { geometry: new THREE.BoxGeometry(0.18, 0.025, 0.02), color: MATTE_BLACK, position: [-0.245, 0.8, 0.29] },
      { geometry: new THREE.BoxGeometry(0.18, 0.025, 0.02), color: MATTE_BLACK, position: [0.245, 0.8, 0.29] },
      // worktop (top surface at 0.9, back flush, small overhang at the front)
      { geometry: new THREE.BoxGeometry(1.0, 0.04, 0.6), color: WORKTOP, position: [0, 0.88, 0] },
      // basin: dark inner slab flush into the worktop
      { geometry: new THREE.BoxGeometry(0.5, 0.015, 0.38), color: BASIN, position: [0, 0.905, 0.01] },
      // raised steel rim around the basin (four thin edges)
      { geometry: new THREE.BoxGeometry(0.54, 0.02, 0.02), color: STEEL, position: [0, 0.915, 0.21] },
      { geometry: new THREE.BoxGeometry(0.54, 0.02, 0.02), color: STEEL, position: [0, 0.915, -0.19] },
      { geometry: new THREE.BoxGeometry(0.02, 0.02, 0.42), color: STEEL, position: [-0.26, 0.915, 0.01] },
      { geometry: new THREE.BoxGeometry(0.02, 0.02, 0.42), color: STEEL, position: [0.26, 0.915, 0.01] },
      // tall faucet: riser, top arm reaching over the basin, short down spout
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.32, 8), color: STEEL, position: [0, 1.06, -0.24] },
      { geometry: new THREE.BoxGeometry(0.035, 0.035, 0.2), color: STEEL, position: [0, 1.22, -0.15] },
      { geometry: new THREE.BoxGeometry(0.03, 0.08, 0.03), color: STEEL, position: [0, 1.18, -0.06] },
    ];
  },
  animations: [],
});
